import {styled} from "@mui/material/styles"
import {Box, Divider, Link as MUILink, Typography} from "@mui/material"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const BurgerSecondaryNavSectionTitle = styled("div")`
    display: flex;
    align-items: center;
    padding: 0.25rem 1rem;
    height: 2.75rem;
`
export const BurgerSecondaryNavCategoryTitle = styled(Typography)`
    font-family: ${({theme}) => theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
`
export const BurgerSecondaryNavSectionLinks = styled("div")`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gao: 0.25rem;
    padding: 0 1rem;
    justify-content: space-between;
    align-items: center;
`

export const BurgerSecondaryNavSectionLink = styled("div")`
    width: calc(50% - 0.5rem);
    padding: 0.375rem 0;
`

export const BurgerSecondaryNavLink = styled(MUILink)`
    color: ${({theme}) => `${theme.uxfabric.components.link.inherit.enabled.textColor}`};
    text-transform: ${({theme}) => theme.uxfabric.global.body1.textTransform};
    line-height: ${({theme}) => theme.uxfabric.global.body1.lineHeight};
    text-decoration: none;
`

export const BurgerSecondaryNavDivider = styled(Divider)`
    height: 2px;
`

export type BoxProps = {
    isFirstSection: boolean
}

export const StyledBox = styled(Box, {
    shouldForwardProp: prop => prop !== "isFirstSection",
})<BoxProps>`
    margin-top: ${props => (props.isFirstSection ? 0 : "1rem")};
    letter-spacing: ${({theme}) => theme.uxfabric.global.subtitle2.letterSpacing};
`
